import { Navigate, useRoutes } from 'react-router-dom';
import { useSelector } from 'react-redux';

// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import HomePage from './pages/public/HomePage';
import ResultsPage from './pages/public/ResultsPage';
import WinnersPage from './pages/public/WinnersPage';
import RatesPage from './pages/public/RatesPage';
import HowToPlayPage from './pages/public/HowToPlayPage';
import BlogPage from './pages/BlogPage';
import UserPage from './pages/UserPage';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import ProductsPage from './pages/ProductsPage';
import DashboardAppPage from './pages/DashboardAppPage';
import RegisterPage from './pages/RegisterPage';
import MasterGamePage from './pages/MasterGamePage';
import ResultDeclareResult from './pages/ResultDeclareResult';
import WinnersListPage from './pages/WinnersListPage';
import GameTypesPage from './pages/GameTypesPage';
import GameRatesPage from './pages/GameRatesPage';
import BidPage from './pages/BidPage';
import PendingResultPage from './pages/PendingResultPage';
import WithdrwalRequestPage from './pages/WithdrwalRequestPage';
import WalletHistoryPage from './pages/WalletHistoryPage';
import UserInfoPage from './pages/UserInfoPage';
import SettingPage from './pages/SettingPage';
import WalletRequestPage from './pages/WalletRequestPage';

export default function Router() {
  const token = localStorage.getItem('token');
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn) || token;

  // The public marketing site and the admin panel are one deployment:
  //   /        -> landing page
  //   /admin   -> admin panel (login when signed out)
  const routes = useRoutes([
    // public site
    { path: '/', element: <HomePage /> },
    { path: '/results', element: <ResultsPage /> },
    { path: '/winners', element: <WinnersPage /> },
    { path: '/rates', element: <RatesPage /> },
    { path: '/how-to-play', element: <HowToPlayPage /> },

    {
      path: '/admin/login',
      element: isLoggedIn ? <Navigate to="/admin/app" replace /> : <LoginPage />,
    },
    {
      path: '/admin/register',
      element: isLoggedIn ? <Navigate to="/admin/app" replace /> : <RegisterPage />,
    },
    {
      path: '/admin',
      element: isLoggedIn ? <DashboardLayout /> : <Navigate to="/admin/login" replace />,
      children: [
        { element: <Navigate to="/admin/app" replace />, index: true },
        { path: 'app', element: <DashboardAppPage /> },
        { path: 'user', element: <UserPage /> },
        { path: 'user/:id', element: <UserInfoPage /> },
        { path: 'products', element: <ProductsPage /> },
        { path: 'setting', element: <SettingPage /> },
        { path: 'blog', element: <BlogPage /> },
        { path: 'master-game', element: <MasterGamePage /> },
        { path: 'game-types', element: <GameTypesPage /> },
        { path: 'game-rates', element: <GameRatesPage /> },
        { path: 'game-bids', element: <BidPage /> },
        { path: 'result-game-declared', element: <ResultDeclareResult /> },
        { path: 'pending-result', element: <PendingResultPage /> },
        { path: 'winners-list', element: <WinnersListPage /> },
        { path: 'withdrawal-requests', element: <WithdrwalRequestPage /> },
        { path: 'wallet-requests', element: <WalletRequestPage /> },
        { path: 'wallet-history', element: <WalletHistoryPage /> },
      ],
    },

    // Old links keep working.
    { path: '/login', element: <Navigate to="/admin/login" replace /> },
    { path: '/dashboard', element: <Navigate to="/admin/app" replace /> },
    { path: '/dashboard/*', element: <Navigate to="/admin/app" replace /> },

    {
      element: <SimpleLayout />,
      children: [{ path: '404', element: <Page404 /> }],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);

  return routes;
}
